
export const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Services', href: '/services' },
  { name: 'Portfolio', href: '/portfolio' },
  { name: 'About', href: '/about' },
  { name: 'Contact', href: '/contact' }
];

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' }
];

export const services = [
  {
    id: 1,
    title: 'Renovation Works',
    description:
      'Complete renovation of apartments, houses and commercial premises using quality materials',
    icon: 'ri-hammer-line',
    image:
      'https://public.readdy.ai/ai/img_res/385df635a01f4e3bf9154ccef402b061.jpg'
  },
  {
    id: 2,
    title: 'Painting Works',
    description:
      'Interior and exterior painting of walls, ceilings, facades with professional approach',
    icon: 'ri-brush-line',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20painters%20working%20on%20interior%20walls%20in%20Swiss%20home%2C%20clean%20white%20walls%20being%20painted%2C%20modern%20tools%20and%20equipment%2C%20minimalist%20clean%20workspace%2C%20natural%20lighting&width=400&height=300&seq=painting1&orientation=landscape'
  },
  {
    id: 3,
    title: 'Plastering Works',
    description: 'Wall leveling, decorative plaster, surface restoration',
    icon: 'ri-tools-line',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20plastering%20work%20on%20walls%20in%20Swiss%20building%2C%20smooth%20wall%20surfaces%20being%20prepared%2C%20construction%20tools%20and%20materials%2C%20clean%20work%20environment%2C%20quality%20craftsmanship&width=400&height=300&seq=plastering1&orientation=landscape'
  },
  {
    id: 4,
    title: 'Flooring',
    description:
      'Installation of parquet, laminate, tiles, linoleum with substrate preparation',
    icon: 'ri-layout-grid-line',
    image:
      'https://static.readdy.ai/image/42d13efc32449c379a28fcec32248951/54f23b008e6beda815f7bd14f3356bfe.jpeg'
  },
  {
    id: 5,
    title: 'Facade Works',
    description:
      'Facade insulation, cladding, repair and painting of exterior walls',
    icon: 'ri-building-line',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20facade%20work%20on%20Swiss%20building%20exterior%2C%20workers%20on%20scaffolding%20renovating%20building%20facade%2C%20clean%20modern%20architecture%2C%20quality%20construction%20materials%2C%20Alpine%20background&width=400&height=300&seq=facade1&orientation=landscape'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Geneva',
    rating: 5,
    text:
      'Outstanding renovation work on our apartment. The team was professional, punctual, and delivered exceptional quality. Highly recommend Alpbuild for any construction project.',
    project: 'Apartment renovation'
  },
  {
    id: 2,
    name: 'Michael Weber',
    location: 'Lausanne',
    rating: 5,
    text:
      'Excellent facade work and insulation. The project was completed on time and within budget. Very satisfied with the professional approach and attention to detail.',
    project: 'Facade insulation'
  },
  {
    id: 3,
    name: 'Elena Rossi',
    location: 'Montreux',
    rating: 5,
    text:
      'Perfect painting and finishing work in our new home. Clean, precise work with high-quality materials. The team exceeded our expectations.',
    project: 'Interior painting'
  },
  {
    id: 4,
    name: 'David Martinez',
    location: 'Vaud',
    rating: 5,
    text:
      'Complete office renovation was handled professionally from start to finish. Great communication and excellent results. Will definitely work with Alpbuild again.',
    project: 'Office renovation'
  }
];

export const portfolio = [
  // Interior Finishing Works
  {
    id: 1,
    title: 'Apartment Plastering Works',
    category: 'Interior Finishing',
    location: 'Geneva',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20interior%20plastering%20work%20in%20Swiss%20apartment%2C%20smooth%20white%20walls%20being%20finished%2C%20high%20quality%20craftsmanship%2C%20clean%20modern%20interior%20space%2C%20natural%20lighting%20showing%20perfect%20wall%20texture%20and%20finish&width=600&height=400&seq=portfolio-plaster1&orientation=landscape',
    description: 'Wall leveling and decorative plaster in a 4-room apartment'
  },
  {
    id: 2,
    title: 'House Woodwork',
    category: 'Interior Finishing',
    location: 'Vaud',
    image:
      'https://readdy.ai/api/search-image?query=Beautiful%20custom%20woodwork%20installation%20in%20Swiss%20home%20interior%2C%20elegant%20wooden%20panels%20and%20trim%2C%20quality%20carpentry%20craftsmanship%2C%20warm%20natural%20wood%20tones%2C%20modern%20minimalist%20design%20with%20professional%20finish&width=600&height=400&seq=portfolio-wood1&orientation=landscape',
    description: 'Installation of wooden panels and carpentry work'
  },
  {
    id: 3,
    title: 'Complete Office Finishing',
    category: 'Interior Finishing',
    location: 'Lausanne',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20office%20interior%20finishing%20in%20Lausanne%20Switzerland%2C%20professional%20construction%20work%20with%20clean%20walls%20and%20quality%20materials%2C%20contemporary%20business%20space%20design%2C%20bright%20natural%20lighting%2C%20Swiss%20quality%20standards&width=600&height=400&seq=portfolio-office1&orientation=landscape',
    description: 'Complete interior finishing of commercial space'
  },

  // Painting and Coatings
  {
    id: 4,
    title: 'Wall and Ceiling Painting',
    category: 'Painting & Coatings',
    location: 'Geneva',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20interior%20painting%20work%20in%20Geneva%20apartment%2C%20painters%20applying%20smooth%20white%20paint%20on%20walls%20and%20ceilings%2C%20clean%20workspace%20with%20quality%20tools%2C%20perfect%20finish%20and%20attention%20to%20detail%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-paint1&orientation=landscape',
    description: 'Professional painting of residential space'
  },
  {
    id: 5,
    title: 'Decorative Coatings',
    category: 'Painting & Coatings',
    location: 'Montreux',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20decorative%20wall%20coating%20in%20Swiss%20luxury%20home%2C%20textured%20decorative%20finish%20with%20sophisticated%20design%2C%20high-end%20interior%20materials%2C%20professional%20application%20technique%2C%20warm%20ambient%20lighting%20showcasing%20texture&width=600&height=400&seq=portfolio-decorative1&orientation=landscape',
    description: 'Application of decorative coatings in private house'
  },
  {
    id: 6,
    title: 'Commercial Property Painting',
    category: 'Painting & Coatings',
    location: 'Vaud',
    image:
      'https://readdy.ai/api/search-image?query=Commercial%20space%20painting%20project%20in%20Vaud%20Switzerland%2C%20large%20interior%20walls%20being%20professionally%20painted%2C%20modern%20business%20environment%20quality%20paint%20application%20clean%20professional%20workspace%20Swiss%20construction%20standards&width=600&height=400&seq=portfolio-commercial1&orientation=landscape',
    description: 'Restaurant painting using premium materials'
  },

  // Floor Coverings
  {
    id: 7,
    title: 'Parquet Installation',
    category: 'Floor Coverings',
    location: 'Geneva',
    image:
      'https://readdy.ai/api/search-image?query=Beautiful%20parquet%20flooring%20installation%20in%20Geneva%20home%2C%20professional%20craftsman%20laying%20high%20quality%20wooden%20floor%2C%20elegant%20herringbone%20pattern%2C%20natural%20wood%20tones%2C%20precision%20work%20and%20perfect%20alignment%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-parquet1&orientation=landscape',
    description: 'Premium parquet flooring installation'
  },
  {
    id: 8,
    title: 'Ceramic Tiles',
    category: 'Floor Coverings',
    location: 'Lausanne',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20ceramic%20tile%20installation%20in%20Swiss%20bathroom%2C%20modern%20large%20format%20tiles%20being%20laid%2C%20precise%20alignment%20and%20spacing%2C%20quality%20materials%20and%20craftsmanship%2C%20clean%20contemporary%20design%2C%20natural%20lighting%20showing%20perfect%20finish&width=600&height=400&seq=portfolio-tiles1&orientation=landscape',
    description: 'Ceramic tile installation in bathroom and kitchen'
  },
  {
    id: 9,
    title: 'Office Laminate',
    category: 'Floor Coverings',
    location: 'Vaud',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20laminate%20flooring%20installation%20in%20Swiss%20office%20space%2C%20professional%20workers%20laying%20quality%20laminate%20contemporary%20wood-look%20finish%20clean%20business%20environment%20precise%20installation%20technique%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-laminate1&orientation=landscape',
    description: 'Laminate installation in office space'
  },

  // Facades and Exterior Insulation
  {
    id: 10,
    title: 'House Facade Insulation',
    category: 'Facades & Insulation',
    location: 'Vaud',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20facade%20insulation%20work%20on%20Swiss%20house%20exterior%2C%20workers%20installing%20thermal%20insulation%20panels%20on%20building%20facade%20modern%20construction%20materials%20Alpine%20landscape%20background%20quality%20exterior%20renovation%20work&width=600&height=400&seq=portfolio-insulation1&orientation=landscape',
    description: 'Complete insulation and cladding of private house'
  },
  {
    id: 11,
    title: 'Building Facade Renovation',
    category: 'Facades & Insulation',
    location: 'Geneva',
    image:
      'https://readdy.ai/api/search-image?query=Building%20facade%20renovation%20in%20Geneva%20Switzerland%2C%20workers%20on%20scaffolding%20restoring%20exterior%20walls%20modern%20facade%20materials%20and%20finishes%20professional%20construction%20work%20urban%20Swiss%20architecture%20quality%20craftsmanship&width=600&height=400&seq=portfolio-facade1&orientation=landscape',
    description: 'Restoration and painting of apartment building facade'
  },
  {
    id: 12,
    title: 'Facade Rendering',
    category: 'Facades & Insulation',
    location: 'Montreux',
    image:
      'https://readdy.ai/api/search-image?query=Exterior%20facade%20plastering%20work%20on%20Swiss%20villa%2C%20professional%20rendering%20application%20on%20building%20exterior%20smooth%20quality%20finish%20modern%20construction%20techniques%20Lake%20Geneva%20region%20landscape%20high-end%20craftsmanship&width=600&height=400&seq=portfolio-render1&orientation=landscape',
    description: 'Decorative rendering application on villa facade'
  },

  // Other Specific Projects
  {
    id: 13,
    title: 'Complete Apartment Renovation',
    category: 'Special Projects',
    location: 'Geneva',
    image:
      'https://readdy.ai/api/search-image?query=Complete%20apartment%20renovation%20transformation%20in%20Geneva%2C%20before%20and%20after%20modern%20interior%20redesign%20comprehensive%20construction%20work%20quality%20finishes%20throughout%20contemporary%20Swiss%20living%20space%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-renovation1&orientation=landscape',
    description: 'Complete renovation with redesign and new layout'
  },
  {
    id: 14,
    title: 'Restaurant Transformation',
    category: 'Special Projects',
    location: 'Lausanne',
    image:
      'https://readdy.ai/api/search-image?query=Restaurant%20transformation%20project%20in%20Lausanne%20Switzerland%2C%20modern%20dining%20space%20renovation%20with%20new%20flooring%20walls%20and%20finishes%20professional%20commercial%20construction%20elegant%20hospitality%20design%20quality%20craftsmanship%20throughout&width=600&height=400&seq=portfolio-restaurant1&orientation=landscape',
    description: 'Complete restaurant reconstruction with new concept'
  },
  {
    id: 15,
    title: 'Historic Building Renovation',
    category: 'Special Projects',
    location: 'Vaud',
    image:
      'https://readdy.ai/api/search-image?query=Historic%20building%20renovation%20in%20Vaud%20Switzerland%2C%20careful%20restoration%20work%20preserving%20original%20character%20quality%20craftsmanship%20on%20traditional%20architecture%20modern%20standards%20applied%20to%20heritage%20property%20Swiss%20Alps%20background&width=600&height=400&seq=portfolio-historic1&orientation=landscape',
    description: 'Careful restoration preserving historical character'
  }
];

export const contact = {
  phone: '+41 77 218 45 02',
  email: 'domdavida86@gmail.com',
  address: 'Switzerland, Vaud and Geneva cantons',
  whatsapp: '+41772184502',
  workingHours: 'Mon-Fri: 7:00-17:00'
};
